import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API, auth } from '../finance/shared';
import { EmptyState } from '../../../components/dashboard/TodaySchedule';
import { toast } from '../../../lib/toast';

const STATUS_LABELS = {
  draft: { text: 'مسودة', cls: 'bg-slate-100 text-slate-600' },
  opened: { text: 'تم فتح واتساب', cls: 'bg-amber-50 text-amber-700' },
  confirmed_sent: { text: 'تم تأكيد الإرسال', cls: 'bg-emerald-50 text-emerald-700' },
  skipped: { text: 'تخطي', cls: 'bg-slate-100 text-slate-500' },
  failed: { text: 'فشل — رقم غير صالح', cls: 'bg-red-50 text-red-600' },
};

const fmtDateTime = (iso) => { if (!iso) return ''; try { return new Date(iso).toLocaleString('ar-SA'); } catch { return iso; } };

// «سجل الرسائل»: كل محاولة مُسجَّلة — الحالة الافتراضية «تم فتح واتساب» فقط، وليس «تم الإرسال»
export const LogTab = () => {
  const [logs, setLogs] = useState([]);
  const [statusFilter, setStatusFilter] = useState('');
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    axios.get(`${API}/whatsapp/log`, { ...auth(), params: statusFilter ? { status: statusFilter } : {} })
      .then((res) => setLogs(res.data || []))
      .catch(() => toast.error('تعذّر تحميل السجل'))
      .finally(() => setLoading(false));
  };

  useEffect(load, [statusFilter]);

  const confirmSent = async (id) => {
    try {
      await axios.put(`${API}/whatsapp/log/${id}/status`, { status: 'confirmed_sent' }, auth());
      load();
    } catch { toast.error('تعذّر التحديث'); }
  };

  return (
    <div className="rounded-xl border border-slate-200 bg-white" data-testid="communication-log-tab">
      <div className="flex items-center justify-between border-b border-slate-100 px-4 py-3">
        <span className="text-sm font-bold text-slate-800">سجل محاولات التواصل ({logs.length})</span>
        <select value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)} data-testid="communication-log-status-filter" className="rounded-lg border border-slate-200 bg-white px-3 py-1.5 text-sm">
          <option value="">كل الحالات</option>
          {Object.entries(STATUS_LABELS).map(([k, v]) => <option key={k} value={k}>{v.text}</option>)}
        </select>
      </div>

      {loading ? (
        <div className="space-y-2 p-4">{[1, 2, 3].map((i) => <div key={i} className="h-12 animate-pulse rounded-lg bg-slate-100" />)}</div>
      ) : logs.length === 0 ? (
        <div className="p-6"><EmptyState icon="inbox" text="لا توجد رسائل مسجَّلة بعد" testId="communication-log-empty" /></div>
      ) : (
        <div className="max-h-[520px] overflow-y-auto divide-y divide-slate-50">
          {logs.map((log) => (
            <div key={log.id} className="flex items-center justify-between px-4 py-3" data-testid="communication-log-row">
              <div>
                <p className="text-sm font-semibold text-slate-800">{log.recipient_name}</p>
                <p className="text-xs text-slate-400">{log.template_name || 'رسالة مخصصة'} · {log.user_name} · {fmtDateTime(log.created_at)}</p>
              </div>
              <div className="flex items-center gap-2">
                <span className={`rounded-full px-2.5 py-1 text-xs font-semibold ${STATUS_LABELS[log.status]?.cls || 'bg-slate-100 text-slate-600'}`} data-testid="communication-log-status-badge">
                  {STATUS_LABELS[log.status]?.text || log.status}
                </span>
                {log.status === 'opened' && (
                  <button onClick={() => confirmSent(log.id)} data-testid="communication-log-confirm-btn" className="rounded-lg bg-emerald-600 px-2.5 py-1 text-xs font-bold text-white hover:bg-emerald-700">
                    تأكيد الإرسال
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
